import { jsx } from "react/jsx-runtime";
import SvgIcon from "@mui/material/SvgIcon/index.js";
const CheckedIcon = (props) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, children: /* @__PURE__ */ jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V5C21 3.895 20.105 3 19 3ZM10.707 16.707C10.316 17.098 9.683 17.098 9.293 16.707L6 13.414C5.61 13.024 5.61 12.39 6 12C6.39 11.61 7.024 11.61 7.414 12L10 14.586L16.586 8C16.976 7.61 17.61 7.61 18 8C18.39 8.39 18.39 9.024 18 9.414L10.707 16.707Z",
      fill: "currentColor"
    }
  ) }) });
};
export {
  CheckedIcon
};
